import React, { useState, useEffect } from 'react';

import { Title } from '@gerdau/hefesto/Title';
import { Button, Icon } from '@gerdau/hefesto';

import { Breadcrumbs, InformationPanel } from '@gerdau/hefesto-mais-web';

import { ERoutes } from '../../../../routes';
import { actionsOptions } from '../OrdersTable/types';
import { EPurchaseRoutes } from '../../../Purchase/purchase.routes';
import {
  HeaderButtonsContainer,
  HeaderSection,
  OrderDetailContainer,
  Header,
  Container,
  CrossSellSection,
  CrossSellSidebar,
  PageWrapper
} from './styles';
import { SalesOrder } from './SalesOrder';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';
import { useHistory, useParams } from 'react-router-dom';
import { SalesOrderItemTable } from '../../../../store/ducks/new-long-steel-orders/types';
import { EOrdersRoutes } from '../../orders.routes';
import { ResumeSection } from './ResumeSection';
import { convertFilteredOrdersToIOpenOrdersTableDataSource } from '../../../../store/ducks/new-long-steel-orders';
import {
  repeatOrderItems,
  validationUpdateItems
} from '../../../../store/ducks/new-long-steel-orders/actions';
import { useCartService } from '../../../../services/MVP/useCartService';
import { updateLongSteelShoppingCartSettings } from '../../../../store/ducks/long-steel-shopping-cart/actions';
import { EOrderTab } from '../../../../store/ducks/long-steel-orders/types';
import { addToast } from '../../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../../store/ducks/toast/types';
import { EOrderSettingsRoutes } from '../../../Purchase/LongSteel/OrderSettingsMvp/orderSettings.routes';
import { ELocalStorageKey } from '../../../../services/EGerdauService/types';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import moment from 'moment';
import { magentoURLBuilder } from '../../../../utils/magentoUrlBuilder';
import { useAuth } from '../../../../services/MVP/useAuth';
import { commerceApi } from '../../../../services/api';
import { EndpointsMvp } from '../../../../services/MVP/enum';
import { BulkCartResponse, NewCartItem } from '../../../../services/MVP/models';
import { useBulkErrorToast } from '../../../../services/MVP/useBulkErrorToast';
import {
  setTipoCompraForSku,
  setLastTipoCompra
} from '../../../../services/MVP/tipoCompraMap';
import useIsCommerceUser from '../../../../hooks/useIsCommerceUser';
import useIsBusinessTypeCG from '../../../../hooks/useIsBusinessTypeCG';
import {
  Z002_CUSTOMER_TYPE,
  SHIP_TO_BP_TYPE
} from '../../../../utils/commerceUser';
import { CrossSellProducts } from '../../../Purchase/LongSteel/ShoppingCartMVP/CrossSellProducts';
import {
  checkCrossSellAvailable,
  cleanCrossSellItems
} from '../../../../store/ducks/cross-sell/actions';
import { useApiInstance } from '../../../../services/MVP/useApiInstance';
import { GetFlag } from '../../../../utils/featureFlag';
import {
  FEATURE_FLAG_CROSS_SELL,
  FEATURE_FLAG_CROSS_SELL_DYNAMIC,
  FEATURE_FLAG_CROSS_SELL_ORDER_DETAIL,
  FEATURE_FLAG_CROSS_SELL_TOP,
  FEATURE_FLAG_CROSS_SELL_VERTICAL,
  CROSS_SELL_VERTICAL_BREAKPOINT
} from '../../../../utils/cross-sell';
import useIsScreenSmallerThan from '../../../../hooks/useIsScreenSmallerThan';

export const OrderDetail = () => {
  const { orderId } = useParams<{ orderId: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const { dispatchBulkErrorToast } = useBulkErrorToast();
  const { getHeaders } = useAuth();

  const { createNewCart, addBulkCartItem } = useCartService();

  const ordersState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders
  );
  const activeTabState = ordersState[ordersState.tableType || EOrderTab.OPEN];
  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );
  const shoppingCartState = useSelector(
    (state: ApplicationState) => state.longSteelShoppingCart
  );

  const isUserAdmin = useSelector(
    (state: ApplicationState) => state.user.isManager
  );
  const userState = useSelector((state: ApplicationState) => state.user);
  const purchaseCustomers = useSelector((state: ApplicationState) =>
    isUserAdmin
      ? state.customers.customers
      : state.customers.customers.filter((customer) =>
          userState.roles.ordersInputCustomers.includes(customer.customerId)
        )
  );

  const isPurchaseMvp = useIsCommerceUser();
  const isBusinessTypeCG = useIsBusinessTypeCG();

  const [, setCrossSellKey] = useState('');
  const [crossSellDismissed, setCrossSellDismissed] = useState(false);
  const apiInstance = useApiInstance();
  const crossSellFeatureFlag = GetFlag(FEATURE_FLAG_CROSS_SELL);
  const crossSellOrderDetailFlag = GetFlag(
    FEATURE_FLAG_CROSS_SELL_ORDER_DETAIL
  );
  const crossSellNewFlow = GetFlag(FEATURE_FLAG_CROSS_SELL_DYNAMIC);
  const crossSellTopFlag = GetFlag(FEATURE_FLAG_CROSS_SELL_TOP);
  const crossSellVerticalFlag = GetFlag(FEATURE_FLAG_CROSS_SELL_VERTICAL);
  const filterEmittersFlag = GetFlag('filter_emitters');
  const isSmallScreen = useIsScreenSmallerThan(CROSS_SELL_VERTICAL_BREAKPOINT);
  const crossSellItems = useSelector((state: ApplicationState) =>
    state.crossSell.items.filter(
      (p) => !!p.price?.creditPrice && Number(p.price.creditPrice) > 0
    )
  );
  const crossSellLoading = useSelector(
    (state: ApplicationState) => state.crossSell.loading
  );

  useEffect(() => {
    setCrossSellDismissed(false);
    dispatch(cleanCrossSellItems());

    if (!crossSellFeatureFlag || !crossSellOrderDetailFlag || !isPurchaseMvp)
      return;

    const orderDetail = activeTabState.orderDetail as
      | SalesOrderItemTable[]
      | undefined;
    if (!orderDetail) return;

    const filteredData =
      convertFilteredOrdersToIOpenOrdersTableDataSource(orderDetail);
    if (!filteredData.length) return;

    const soldTo = filteredData[0]?.soldTo?.code;
    const shipTo = filteredData[0]?.shipTo?.code;
    if (!soldTo || !shipTo) return;

    dispatch(
      checkCrossSellAvailable({
        cartItems: crossSellNewFlow
          ? undefined
          : filteredData.map(
              (item) => ({ sku: item.sku } as unknown as NewCartItem)
            ),
        divisions: crossSellNewFlow
          ? undefined
          : filteredData.map((item) => item.division),
        businessPartners: [shipTo],
        soldTo: soldTo !== shipTo ? soldTo : undefined,
        commerceApi: apiInstance,
        useNewFlow: crossSellNewFlow,
        scope: 'details'
      })
    );

    return () => {
      dispatch(cleanCrossSellItems());
    };
  }, [orderId]); // eslint-disable-line

  if (!activeTabState.orderDetail) {
    if (!activeTabState.items && !ordersState.loading) {
      history.replace(`${ERoutes.ORDERS}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`);
    }
    return null;
  }

  const items = activeTabState.orderDetail as SalesOrderItemTable[];

  const data = convertFilteredOrdersToIOpenOrdersTableDataSource(items);

  if (!data || data.length === 0) {
    history.replace(`${ERoutes.ORDERS}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`);
    return null;
  }

  const titleWithOrderNumber = `Ordem de venda nº ${orderId}`;

  const getBreadcrumbs = () => {
    return [
      {
        name: 'Pedidos',
        url: `${ERoutes.ORDERS}`
      },
      {
        name: 'Pedidos de aços longos e planos',
        url: `${ERoutes.ORDERS}/${EOrdersRoutes.LONG_STEEL_ORDERS}`
      },
      {
        name: 'Detalhes da ordem de venda',
        url: ''
      }
    ];
  };

  const sendActionButtonTagging = (click: string) => {
    dispatch(
      sendTagging({
        event: 'acao_dentro_detalhes_pedido',
        click: click,
        screenName: 'LG:Detalhes_do_pedido',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio:
          ordersState.tableType === EOrderTab.OPEN
            ? undefined
            : moment(
                ordersState[ordersState.tableType || EOrderTab.OPEN]
                  .initialInputValues.startDate
              ).format('DD/MM/YYYY'),
        data_fim:
          ordersState.tableType === EOrderTab.OPEN
            ? undefined
            : moment(
                ordersState[ordersState.tableType || EOrderTab.OPEN]
                  .initialInputValues.endDate
              ).format('DD/MM/YYYY')
      })
    );
  };

  const panelOptions = actionsOptions({
    onCancelOrderClick: () => {
      if (data && data.length > 0) {
        dispatch(
          validationUpdateItems({
            itemsSelected: data,
            typeAction: 'cancel'
          })
        );
      }

      sendActionButtonTagging('solicitar_cancelamento');
    },
    onUpdateOrderClick: () => {
      if (data && data.length > 0) {
        dispatch(
          validationUpdateItems({
            itemsSelected: data,
            typeAction: 'update'
          })
        );
      }

      sendActionButtonTagging('solicitar_alteracoes');
    }
  });

  const buyAgain = async () => {
    dispatch(
      sendTagging({
        event: 'comprar_novamente_via_detalhes',
        pedido_id: data[0].id,
        screenName: 'LG:Detalhes_do_pedido',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio:
          ordersState.tableType === EOrderTab.OPEN
            ? undefined
            : moment(
                ordersState[ordersState.tableType || EOrderTab.OPEN]
                  .initialInputValues.startDate
              ).format('DD/MM/YYYY'),
        data_fim:
          ordersState.tableType === EOrderTab.OPEN
            ? undefined
            : moment(
                ordersState[ordersState.tableType || EOrderTab.OPEN]
                  .initialInputValues.endDate
              ).format('DD/MM/YYYY')
      })
    );

    const productsSku = data.map((item) => item.sku);
    const dataItem = data[0] ?? {};
    const emitter = dataItem.soldTo.code;
    const receiver = dataItem.shipTo.code;
    const division = data.map((item) => item.division);
    const hasAcess = purchaseCustomers.some(
      (item) => emitter === item.customerId
    );

    if (!emitter || !division || !hasAcess) {
      return dispatch(
        addToast({
          type: EToastTypes.DANGER,
          message: 'Não é possível repetir esse pedido no momento.',
          durationInMS: 5000,
          labelActionOne: 'Fechar'
        })
      );
    }

    dispatch(
      updateLongSteelShoppingCartSettings({
        ...shoppingCartState,
        emitterId: emitter,
        receiverId: receiver
      })
    );

    try {
      dispatch(repeatOrderItems({ loadingRepeatOrder: true }));
      const cartId = await createNewCart(emitter, receiver, true, false, false);

      const params = magentoURLBuilder({
        term: productsSku.join(','),
        pageSize: 30
      });

      const response = await commerceApi.get(
        `${EndpointsMvp.CATALOG(emitter, receiver)}`,
        {
          params,
          headers: getHeaders({ withCommerceToken: true })
        }
      );

      const dataResponse = response.data.items.map((item: NewCartItem) => ({
        ...item,
        price: item?.extension_attributes?.price_gerdau
          ? JSON.parse(item?.extension_attributes?.price_gerdau ?? '')
          : {}
      }));

      if (
        !dataResponse ||
        dataResponse.length === 0 ||
        !data ||
        data.length === 0 ||
        !cartId
      ) {
        return dispatch(
          addToast({
            type: EToastTypes.DANGER,
            message: 'Os items desse pedido não estão disponíveis no momento',
            durationInMS: 5000,
            labelActionOne: 'Fechar'
          })
        );
      }

      const dataItems = dataResponse.map((itm: SalesOrderItemTable) => {
        const orderItem = data.find(
          (item) => String(item.sku) === String(itm.sku)
        );
        return {
          ...itm,
          qty: orderItem?.productState?.requestedQuantity ?? 1,
          extension_attributes: {
            measure_unity_gerdau:
              orderItem?.productState?.requestedMeasureUnit ??
              orderItem?.productState?.billedMeasureUnit ??
              orderItem?.productState?.billingMeasureUnit ??
              orderItem?.productState?.pendingMeasureUnit ??
              orderItem?.productState?.deliveryMeasureUnit ??
              orderItem?.productState?.shipmentMeasureUnit ??
              orderItem?.measureUnits?.[0]?.measure ??
              '',
            destination_gerdau:
              orderItem?.destination ?? itm?.price?.destination ?? '',
            payment_type_gerdau:
              orderItem?.conditions?.paymentTerms ??
              orderItem?.billing?.[0]?.paymentTerms ??
              itm?.price?.paymentTerms ??
              '',
            sap_fields: {
              o_header_sap: [],
              o_item_sap: [],
              o_price_sap: []
            },
            tax_benefit_gerdau: ''
          }
        };
      });

      const bulkResponse = (await addBulkCartItem({
        items: dataItems,
        withOptions: false,
        withPrice: false,
        emitterId: emitter,
        customerId: receiver
      })) as BulkCartResponse;

      const bulkItems = bulkResponse?.items ?? [];

      dispatchBulkErrorToast(bulkItems, bulkResponse?.errors ?? []);

      if (bulkItems.length > 0) {
        dispatch(
          sendTagging({
            event: 'add_to_cart',
            ecommerce: {
              currency: 'BRL',
              value: '',
              screenName: 'compra_novamente',
              tipo_compra: 'compra_novamente',
              items: dataItems.map(
                (item: { sku: string; qty?: number | null }) => ({
                  screenName: 'compra_novamente',
                  tipo_compra: 'compra_novamente',
                  item_id: String(item.sku),
                  item_name: '',
                  quantity: String(item.qty ?? '1')
                })
              )
            }
          })
        );

        dataItems.forEach((item: { sku: string }) =>
          setTipoCompraForSku(String(item.sku), 'compra_novamente')
        );
        setLastTipoCompra('compra_novamente');

        localStorage.setItem(
          ELocalStorageKey.LONG_STEEL_MENU_NAVEGATION,
          JSON.stringify([{ name: 'Comprar novamente', url: 'order-detail' }])
        );
        return history.push({
          pathname: `${ERoutes.PURCHASE}/${EPurchaseRoutes.LONG_STEEL}/commerce/${EOrderSettingsRoutes.SHOPPING_CART}`,
          state: { isRepeatOrder: true }
        });
      }

      throw new Error();
    } catch (error) {
      console.error('Failed to add items to cart:', error);
      dispatch(
        addToast({
          type: EToastTypes.DANGER,
          message: 'Falha ao repetir o pedido, por favor, tente novamente.',
          durationInMS: 5000,
          labelActionOne: 'Fechar'
        })
      );
    } finally {
      dispatch(repeatOrderItems({ loadingRepeatOrder: false }));
    }
  };

  const orderBpSoldTo = data[0]?.soldTo?.code;
  const orderBpShipTo = data[0]?.shipTo?.code;

  const orderSkus = data.map((item) => item.sku);
  const filteredCrossSellItems = crossSellItems.filter(
    (item) => !orderSkus.includes(String(item.sku))
  );

  const showCrossSell =
    isPurchaseMvp &&
    userState.userPermissions.hasOrderInputAccess &&
    crossSellFeatureFlag &&
    crossSellOrderDetailFlag;
  const hasCrossSellContent =
    crossSellLoading || filteredCrossSellItems.length > 0;
  const showVertical =
    showCrossSell &&
    crossSellVerticalFlag &&
    !isSmallScreen &&
    hasCrossSellContent;

  const handleCrossSellItemAdded = () => {
    localStorage.setItem(
      ELocalStorageKey.LONG_STEEL_MENU_NAVEGATION,
      JSON.stringify([{ name: 'Comprar novamente', url: 'order-detail' }])
    );
  };

  const soldToCustomer = purchaseCustomers.find(
    (c) => c.customerId === data[0]?.soldTo?.code
  );

  const hasPermission =
    userState.userPermissions.hasOrderInputAccess &&
    !!data[0]?.soldTo?.code &&
    userState.roles.ordersInputCustomers.includes(data[0].soldTo.code) &&
    isPurchaseMvp &&
    !isBusinessTypeCG &&
    (!filterEmittersFlag ||
      (soldToCustomer?.customerType !== Z002_CUSTOMER_TYPE &&
        !!soldToCustomer?.bpType &&
        soldToCustomer?.bpType !== SHIP_TO_BP_TYPE));

  return (
    <PageWrapper showVerticalCrossSell={showVertical && !crossSellDismissed}>
      <Container>
        <Header>
          <Breadcrumbs
            breadcrumbItems={getBreadcrumbs()}
            onClick={(e) => {
              history.push(e);
            }}
          />
          <Title level={1}>{titleWithOrderNumber}</Title>
          <HeaderSection>
            <span className="subtitle">
              Acompanhe os detalhes dos seus produtos solicitados.
            </span>

            <HeaderButtonsContainer>
              {hasPermission && (
                <Button name="buy_again" onClick={buyAgain} variant="secondary">
                  Comprar novamente
                </Button>
              )}

              <Button variant="secondary" name="actions-button">
                <InformationPanel
                  trigger={
                    <div>
                      <Button
                        name="action-information-panel"
                        variant="neutral"
                        icon={<Icon option="MoreVertical"></Icon>}
                      ></Button>
                    </div>
                  }
                  position="bottom right"
                  panelOptions={panelOptions}
                />
              </Button>
            </HeaderButtonsContainer>
          </HeaderSection>
        </Header>

        {showCrossSell &&
          !showVertical &&
          crossSellTopFlag &&
          !crossSellDismissed && (
            <CrossSellSection marginTop>
              <CrossSellProducts
                setCrossSellKey={setCrossSellKey}
                filteredItems={filteredCrossSellItems}
                orderSoldTo={orderBpSoldTo}
                orderShipTo={orderBpShipTo}
                screenName="LG:Detalhes_do_pedido"
                onItemAdded={handleCrossSellItemAdded}
                onDismiss={() => setCrossSellDismissed(true)}
                title="Sugestões baseadas na sua compra"
                crossSellContext="details"
              />
            </CrossSellSection>
          )}

        <ResumeSection data={data} />

        <OrderDetailContainer>
          {data.map((item) => (
            <SalesOrder data={item} />
          ))}
        </OrderDetailContainer>

        {showCrossSell &&
          !showVertical &&
          !crossSellTopFlag &&
          !crossSellDismissed && (
            <CrossSellSection>
              <CrossSellProducts
                setCrossSellKey={setCrossSellKey}
                filteredItems={filteredCrossSellItems}
                orderSoldTo={orderBpSoldTo}
                orderShipTo={orderBpShipTo}
                screenName="LG:Detalhes_do_pedido"
                onItemAdded={handleCrossSellItemAdded}
                onDismiss={() => setCrossSellDismissed(true)}
                title="Sugestões baseadas na sua compra"
                crossSellContext="details"
              />
            </CrossSellSection>
          )}
      </Container>

      {showVertical && !crossSellDismissed && (
        <CrossSellSidebar>
          <CrossSellProducts
            setCrossSellKey={setCrossSellKey}
            orientation="vertical"
            filteredItems={filteredCrossSellItems}
            orderSoldTo={orderBpSoldTo}
            orderShipTo={orderBpShipTo}
            screenName="LG:Detalhes_do_pedido"
            onItemAdded={handleCrossSellItemAdded}
            onDismiss={() => setCrossSellDismissed(true)}
            title="Sugestões baseadas na sua compra"
            crossSellContext="details"
          />
        </CrossSellSidebar>
      )}
    </PageWrapper>
  );
};
